export const optionsApi = {
    getOptions: 'v1/api/options',
    createOptions: 'v1/api/options',
    createOptionsV2: 'v2/api/options',
    editOptions: 'v1/api/options',
    editOptionsv2: 'v2/api/options',
    deteleOptions: 'v1/api/options',
    getOptionById: 'v1/api/options/getById/',
    getOptionByIdARU: 'v1/api/options/getOptionById/',
    getOptionCouserType: 'v1/api/options?id=1',
    getOptionsForUniversityDocumentType: 'v1/api/options?id=4',
    getOptionsForApplicationType: 'v1/api/options?id=1712082007',
    getOptionsForIntake: 'v1/api/options?id=13',
    getOptionsForMarksheetType: 'v1/api/options?id=2',
    getOptionsForMarksheetSection: 'v1/api/options?id=3',
    getOptionsForPreviousAcadmicCourse: 'v1/api/options?id=18',
    getOptionsForCampus: 'v1/api/options?id=16',
    getInterviewStatus: 'v1/api/options?id=1721728369',
    getInterviewMode: 'v1/api/options?type=interviewMode',
    getEducationLevel: 'v1/api/options?id=1721987602',
    getDegree: 'v1/api/options?id=1722249482',
    getOverallGrade: 'v1/api/options?id=1722263592',
    getUniversityRequirement: 'v1/api/options?id=1722432322',
    getEnglishType: 'v1/api/options?id=17222494821',
    getInterviewFormTemplate: 'v1/api/options?id=1722409083',
    getGapYear: 'v1/api/options?id=1722921663',
    getBacklogs: 'v1/api/options?id=1722802577',
    getBloodGroup: 'v1/api/options?id=1723207605',
    getBankOptions: 'v1/api/options?id=22',
    getVisaPermits: 'v1/api/options?id=1721981494',
    getHighestQualification: 'v1/api/options?id=1722251208',
    gallwayIntrestType: 'v1/api/options?id=17308060135993',
    // getMonths: 'v1/api/options?id=1724131459',
    // getYears: 'v1/api/options?id=1724132926',
    gceLevel: 'v1/api/options?id=1724225912',
    universityDefault: 'v1/api/options?id=1724303569',
    courseCompareParameters: 'v1/api/courses/schema',
    paymentPlan: 'v1/api/options?type=Payment Plan',
    getAutomationoption:'v1/api/options?id=17271621295755',
    automationFile: 'v1/api/options?id=1727069125',
    OneSignalSubscribe: 'v1/api/auth/subscribeOnsignal?device_type=:deviceType&userId=:userId&playerId=:playerId',
    getAttributes: 'v1/api/options?id=5',
    getMonths: 'v1/api/options?type=Months',
    getYears: 'v1/api/options?type=Salary Years',
    getDegreeBoard: 'v1/api/options?id=2',
    getSubjects:'v1/api/options?id=17399635071655',
    getAllowedStrings: 'v1/api/options?id=17410704434178',
    getAllFormFields: 'v1/api/formFields',
    getCampusesByUniversity: 'v1/api/options/getCampusesByUniversity/',
    getUniFromOptions: 'v1/api/options?id=14',
    getLocation:'v1/api/coursesFilter/13',
    // courseCompareParameters: 'v1/api/courses/schema'
};

// {
//     getOptions: 'v1/api/options',
//     createOptions: 'v1/api/options',
//     editOptions: 'v1/api/options',
//     deteleOptions: 'v1/api/options',
//     getOptionById: 'v1/api/options/getById/',
//     getOptionCouserType: 'v1/api/options?type=Course Type',
//     getOptionsForUniversityDocumentType: 'v1/api/options?type=University Document Type',
//     getOptionsForApplicationType: 'v1/api/options?type=Application Type',
//     getOptionsForIntake: 'v1/api/options?type=Intake',
//     getOptionsForMarksheetType: 'v1/api/options?type=Marksheet Type',
//     getOptionsForMarksheetSection: 'v1/api/options?type=Marksheet Section',
//     getOptionsForPreviousAcadmicCourse: 'v1/api/options?type=Previous Academic Course',
//     getOptionsForCampus: 'v1/api/options?type=Campus',
//     getInterviewStatus: 'v1/api/options?type=interviewStatus',
//     getInterviewMode: 'v1/api/options?type=interviewMode',
//     getEducationLevel: 'v1/api/options?type=Education level',
//     getDegree: 'v1/api/options?type=Degree Menu',
//     getOverallGrade: 'v1/api/options?type=Overall Grade',
//     getUniversityRequirement: 'v1/api/options?type=University Requirement',
//     getEnglishType: 'v1/api/options?type=English Proficiency',
//     getInterviewFormTemplate: 'v1/api/options?type=InterviewFormTemplate',
//     getGapYear: 'v1/api/options?type=Gap Year',
//     getBacklogs: 'v1/api/options?type=Backlogs',
//     getBloodGroup: 'v1/api/options?type=Blood Group',
//     getVisaPermits: 'v1/api/options?type=Visa Permits',
//     getHighestQualification: 'v1/api/options?type=Highest Qualification',
//     getMonths: 'v1/api/options?type=Months',
//     getYears: 'v1/api/options?type=Salary Years',
//     gceLevel: 'v1/api/options?type=GCE Advanced Level Education',
//     universityDefault: 'v1/api/options?type=University Default Filters',
//     courseCompareParameters: 'v1/api/courses/schema'
// };

